import { InsightsAPI } from "@radarly/api/insights";
import { InsightsRepository } from "@radarly/core/insights/repositories/InsightsRepository";
import { SearchParams } from "@radarly/models/search";

interface Dependencies {
  insightsAPI: InsightsAPI;
}

export class RESTInsightsRepository implements InsightsRepository {
  private insightsAPI: InsightsAPI;
  public constructor(dependencies: Dependencies) {
    this.insightsAPI = dependencies.insightsAPI;
  }

  public async getImageClusters(projectId: number, query: SearchParams) {
    return await this.insightsAPI.getImageClustering(projectId, query);
  }
}
